import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import "./INTERIOR_DESIGN_TEMPLATE.css";
import { Api } from "../../../services/api";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import { InteriorDesignTemplate } from "../../../services/Template/interior-design-template";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

const INTERIOR_DESIGN_TEMPLATE = ({pmId}) => {
  const [projectData, setProjectData] = useState([]);
  const [isSaveBtnLoading, setIsSaveBtnLoading] = useState(false);
  const navigate = useNavigate();

  const toast = useRef(null);

  const formik = useFormik({
    initialValues: InteriorDesignTemplate.getFormName(),
    validate: (data) => {

    },

    onSubmit: (data) => {
      setIsSaveBtnLoading(true);
      console.log("data");
      console.log(data);


      data.user_id = localStorage.getItem('user_id');
      data.role_id = localStorage.getItem('role_id');
      var url = Api.API_BASE_URL + 'interior-template/create';


      fetch(url, {
        method: "POST",
        headers: {

        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((Josn) => {
          setIsSaveBtnLoading(false);
          setExistPageWithoutSave(false);
          if (Josn.error != '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

          } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });

            //navigate('/interior-design-dashboard')
            // getUser();
          }

        })
        .catch((error) => {
          setIsSaveBtnLoading(false);
          console.error("Error:", error);
        });


    }
  });


  const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);

  useEffect(() => {
    ProjectOnChange(pmId)
    return () => {
      // Cleanup tasks before the component is unmounted
      if (existPageWithoutSave) {
        // if (window.confirm('Do you want to save changes you made to this document?')) {
        formik.handleSubmit();
        // }
      }
    };
  }, [existPageWithoutSave]);



  const goBack = () => {
    //navigate('/interior-design-dashboard')
  }
  const [preConstructionShedule, setPreConstructionShedule] = useState([1]);
  const handleAddInputForPreConstructionShedule = () => {
    setPreConstructionShedule([...preConstructionShedule, 1]);
  };

  const handleDeleteInputForreConstructionShedule = (index) => {
    setPreConstructionShedule([...preConstructionShedule, 2]);
    var newArray = [...preConstructionShedule];
    newArray.splice(index, 1);
    setPreConstructionShedule(newArray);
  };

  const getProjectDetails = () => {
    // fetch.
    var user_id = localStorage.getItem('user_id');
    var role_id = localStorage.getItem('role_id');
    var _body = {
      userId: user_id,
      role_id: role_id,
    }
    fetch(Api.API_BASE_URL + 'template/get-project-for-template', {
      method: "POST",

      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response.result);
        // setIsLoading(false);
        setProjectData(response.result);


      })
      .catch((error) => {
        // setIsLoading(false);
        console.error("Error:", error);
      });
  }


  const ProjectOnChange = (selectId) => {

    formik.setFieldValue('project_id', selectId)

  }

  //* ________________________________
  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
    fontSize: "18px",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    // textAlign: 'center',
  };

  const cellStyleW = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    backgroundColor:'white',
    paddingTop:'5px'
  };

  const yesCellStyle = {
    ...cellStyleW,
    // background: "#FEC025",
  };

  

  const firstColumnWidth = {
    width: "80px", // Adjust the width as needed
  };

  const dropdownCellStyle = {
    ...yesCellStyle,
    padding: "0",
    // Remove padding to fit the dropdown
  };

  //* ________________________________

  //! -----------------------------------------------
  const renderTextArea = (fieldName, placeholder, maxLine = 2) => (
    <textarea
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      rows={maxLine}
      value={formik.values[fieldName]}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        console.log(e.target.value)

        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', display: 'flex', alignItems: 'center',paddingTop:'8px' }}
    ></textarea>
  );

  const renderInputArea = (fieldName, placeholder, type = 'text') => (
    <input
      type={type}
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      value={formik.values[fieldName]}
      // onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
        console.log(fieldName);
        if (fieldName === 'sitePrep_P_B_C_Date') {
          console.log('Testing');
          formik.setFieldValue('scheduleConstructionStartDate', e.target.value)

        }
        if (fieldName === 'turnOver_C_F_C_Date') {
          formik.setFieldValue('scheduleProjectCompletion', e.target.value)
        }


      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: '100%',
        height: '40px',
        boxSizing: 'border-box',
        border: 'none',
        fontSize: '16px',
        textAlign: 'center',
        marginTop: '0px',
      }}
    />
  );

  const renderSelect = (fieldName) => (
    <select
      name={fieldName}
      id={fieldName}
      value={formik.values[fieldName]}
      onChange={(e) => {

        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', backgroundColor: '#ff0000', border: 'none' }} >

      <option value="NO">No</option>
      <option value="YES">Yes</option>
    </select>
  );


  //! -----------------------------------------------

  //? ------------------------------------------------
  const section_1_body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    // renderInputArea
    return (
      <tr>
        <td style={{ ...cellStyle, minWidth: "250px" }}>{title}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_1, '', 'number')}</td>
        <td style={{ ...cellStyleW, minWidth: "350px" }}>{renderInputArea(fieldName_2, '', '')}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_3, '', 'number')}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_4, '', '')}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_5, '', '')}</td>
      </tr>
    );
  }

  const section_2_body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    // renderInputArea
    return (
      <tr>
        <td style={{ ...cellStyle, minWidth: "300px" }}>{title}</td>

        <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
          {renderSelect(fieldName_1)}
        </td>
        <td style={{ ...cellStyleW, minWidth: "350px" }}>{renderInputArea(fieldName_2, '', '')}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_3, '', 'number')}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_4, '', '')}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_5, '', '')}</td>
      </tr>
    );
  }

  //? ------------------------------------------------


  return (
    <>
      <Toast ref={toast} />
      <form onSubmit={formik.handleSubmit} className="interior-template-form">
        <div className="flex justify-content-end submitbutton">
        {/* <Button label="Archive" severity="help" icon="pi pi-bolt" className="p-button-primary p-2 m-2" /> */}
          {/* <Button type="button" label="Back" className="m-2 p-2 mb-0" onClick={goBack} style={{ backgroundColor: 'gray' }} /> */}
          <Button type="submit" label="Submit" className="m-2 p-2" loading={isSaveBtnLoading} />
        </div>



        <div className="cardd" style={{margin:0,  border:'none',}}>
          <Accordion multiple activeIndex={[0, 1, 2, 3]}>

            <AccordionTab header="ACTIONS STEPS" >

              <div className="table-container" style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", }}>
                  <thead>
                    <tr>
                      <th style={{ ...headerStyle, width: "300px" }} >
                        ACTION STEPS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "250px" }} colSpan={3} >
                        Address:
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto", }} rowSpan={2}  >
                        INTERIOR DESIGNER COMMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} rowSpan={2} >
                        VP CONSTRUCTION OPS COMMENTS ONLY
                      </th>


                    </tr>
                    <tr>
                      <th style={{ ...headerStyle,  }} >
                       
                      </th>

                      <th style={{ ...headerStyle, }} >
                        TOTAL
                      </th>
                      <th style={{ ...headerStyle, }} >
                        COMMENTS
                      </th>
                      <th style={{ ...headerStyle,  }} >
                        % COMPLETE
                      </th>
                      


                    </tr>
                  </thead>

                  <tbody>

                    {section_1_body('ID Contract Amount:', 'IDContractAmountTotal', 'IDContractAmountComments', 'IDContractAmountPerComplete', 'IDContractAmountInterior', 'IDContractAmountVPC')}
                    {section_1_body('Amount Used:', 'AmountUsedTotal', 'AmountUsedComments', 'AmountUsedPerComplete', 'AmountUsedinterior', 'AmountUsedVPC')}
                    {section_1_body('GP%:', 'GpPerTotal', 'GpPerComments', 'GpPerComplete', 'GpPerInterior', 'GpPerVPC')}


                  </tbody>
                </table>
              </div>

            </AccordionTab>

            <AccordionTab header="DELIVERABLES" className="mt-2">

              <div className="table-container" style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", width: "auto" }}>
                  <thead>

                    <tr>
                      <th style={{ ...headerStyle, minWidth: "400px", }} >
                        DELIVERABLES
                      </th>

                      <th style={{ ...headerStyle, minWidth: "auto", }} >
                        COMPLETE YES/NO
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        COMMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >

                      </th>

                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        INTERIOR DESIGNER COMMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        VP CONSTRUCTION OPS COMMENTS
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {section_2_body('Project Preference Sheet Complete', 'ProjectPreferenceComplete', 'ProjectPreferenceComments', 'ProjectPreferencePerComplete', 'ProjectPreferenceInterior', 'ProjectPreferenceVPC')}

                    {section_2_body('RFI\'s up to Date?', 'RFIComplete', 'RFIComments', 'RFIPerComplete', 'RFIInterior', 'RFIVPC')}

                    {section_2_body('Drawings up to date?', 'DrawingsComplete', 'DrawingsComments', 'DrawingsPerComplete', 'Drawingsinterior', 'DrawingsVPC')}

                    {section_2_body('Selection Choices up to date?', 'SelectionsComplete', 'SelectionsComments', 'SelectionsPerComplete', 'SelectionsInterior', 'SelectionsVPC')}

                    {section_2_body('Floor Plans (Concept) - Reno Only', 'FLoorPlanComplete', 'FLoorPlanComments', 'FLoorPlanPerComplete', 'FLoorPlanInterior', 'FLoorPlanVPC')}





                  </tbody>
                </table>
              </div>

            </AccordionTab>

            <AccordionTab header="WEEKLY INTERIOR DESIGN UPDATE" className="mt-2">

              <div className="table-container" style={{ overflowX: "auto" }}>

                <table style={{ borderCollapse: "collapse", }}>

                  <thead>

                    <tr>
                      <th style={{ ...headerStyle, minWidth: "auto", }} >
                        WEEKLY INTERIOR DESIGN UPDATE
                      </th>

                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        VP CONSTRUCTION OPS COMMENTS
                      </th>
                    </tr>

                  </thead>

                  <tbody>
                    <tr>

                      <td style={{ ...cellStyle, minWidth: "", }} >
                        Dear  {renderTextArea('dear', '???? ???',)}
                      </td>
                      <td style={{ ...cellStyle, minWidth: "530px", }} rowSpan={2}>
                        {renderTextArea('dearVPCComments', '', 6)}
                      </td>

                    </tr>
                    <tr>
                      <td style={{}} >
                        <td style={{ ...cellStyle, minWidth: "300px", }} >
                          Here is your weekly summary from:
                        </td>
                        <td style={{ ...cellStyle, minWidth: "150px", backgroundColor: 'gray' }} >
                          <input
                            type="date"
                            name="summaryFrom"
                            id="summaryFrom"
                            value={formik.values['summaryFrom']}
                            onChange={(e) => formik.setFieldValue('summaryFrom', e.target.value)}
                            style={{ width: '100%', textAlign: 'center', fontSize: '16px', height: '32px', color: '#495057' }}

                          />
                        </td>
                        <td style={{ ...cellStyle, minWidth: "100px", textAlign: 'center', fontSize: 20 }} >
                          To
                        </td>
                        <td style={{ ...cellStyle, minWidth: "150px", backgroundColor: 'gray' }} >
                          <input
                            type="date"
                            name="summaryTo"
                            id="summaryTo"
                            value={formik.values['summaryTo']}
                            onChange={(e) => formik.setFieldValue('summaryTo', e.target.value)}
                            style={{ width: '100%', textAlign: 'center', fontSize: '16px', height: '32px', color: '#495057' }}
                          />
                        </td>

                      </td>
                      {/* <td style={{ ...cellStyle, minWidth: "530px", }} >{renderTextArea('summaryVPC', '')}</td> */}

                    </tr>
                  </tbody>
                </table>


                <table style={{ borderCollapse: "collapse",  marginTop: '20px' }}>
                  <thead>
                    <tr>
                      <th style={{ ...headerStyle, width: "300px", }} >
                        ID DOCUMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        Area
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        SELECTIONS
                      </th>
                      <th style={{ ...headerStyle, width: "100px" }} >
                        COMPLETED YES/NO/NA
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        INTERIOR DESIGNER COMMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        ID BID REQ YES/NO/NA
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        PO
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        PO or DRAWING DUE DATE
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        VP CONSTRUCTION OPS COMMENTS
                      </th>


                    </tr>
                  </thead>

                  <tbody>

                    {InteriorDesignTemplate.getFormName().section_4.map((item, index) => {
                      return (
                        index == 0 ? (<tr>
                          <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={4}> Pre Start</td>
                          <td style={{ ...cellStyle }} rowSpan={4} >  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_4.${index}.completed`)} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_4.${index}.interiorDesignerComments`, '')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_4.${index}.idBidReq`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_4.${index}.pO`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_4.${index}.poOrDDue`, '', 'date')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_4.${index}.vPSComments`, '')} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_4.${index}.completed`)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextArea(`section_4.${index}.interiorDesignerComments`, '')} </td>
                            <td style={{ ...cellStyleW, }}>  {renderInputArea(`section_4.${index}.idBidReq`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_4.${index}.pO`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_4.${index}.poOrDDue`, '', 'date')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_4.${index}.vPSComments`, '')} </td>
                          </tr>
                        )
                      )
                    })

                    }
                    {/* SCHEDULES  EXTERIOR  Start */}
                    {InteriorDesignTemplate.getFormName().section_5.map((item, index) => {
                      return (
                        index == 0 ? (<tr>
                          <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={14}> SCHEDULES</td>
                          <td style={{ ...cellStyle }} rowSpan={3} > EXTERIOR  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_5.${index}.completed`)} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_5.${index}.interiorDesignerComments`, '')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_5.${index}.idBidReq`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_5.${index}.pO`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_5.${index}.poOrDDue`, '', 'date')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_5.${index}.vPSComments`, '')} </td>

                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_5.${index}.completed`)} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_5.${index}.interiorDesignerComments`, '')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_5.${index}.idBidReq`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_5.${index}.pO`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_5.${index}.poOrDDue`, '', 'date')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_5.${index}.vPSComments`, '')} </td>

                          </tr>
                        )
                      )
                    })

                    }

                    {/* SCHEDULES  EXTERIOR  End */}
                    {/* SCHEDULES  INTERIOR  start */}
                    {InteriorDesignTemplate.getFormName().section_6.map((item, index) => {
                      return (
                        index == 0 ? (<tr>

                          <td style={{ ...cellStyle }} rowSpan={11} > INTERIOR  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_6.${index}.completed`)} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_6.${index}.interiorDesignerComments`, '')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_6.${index}.idBidReq`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_6.${index}.pO`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_6.${index}.poOrDDue`, '', 'date')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_6.${index}.vPSComments`, '')} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_6.${index}.completed`)} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_6.${index}.interiorDesignerComments`, '')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_6.${index}.idBidReq`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_6.${index}.pO`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_6.${index}.poOrDDue`, '', 'date')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_6.${index}.vPSComments`, '')} </td>
                          </tr>
                        )
                      )
                    })

                    }
                    {/* SCHEDULES  INTERIOR  End */}


                    {/* DRAWINGS  EXTERIOR  Start */}
                    {InteriorDesignTemplate.getFormName().section_7.map((item, index) => {
                      return (
                        index == 0 ? (<tr>
                          <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={15}> DRAWINGS</td>
                          <td style={{ ...cellStyle }} rowSpan={3} > EXTERIOR  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_7.${index}.completed`)} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_7.${index}.interiorDesignerComments`, '')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_7.${index}.idBidReq`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_7.${index}.pO`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_7.${index}.poOrDDue`, '', 'date')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_7.${index}.vPSComments`, '')} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_7.${index}.completed`)} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_7.${index}.interiorDesignerComments`, '')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_7.${index}.idBidReq`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_7.${index}.pO`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_7.${index}.poOrDDue`, '', 'date')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_7.${index}.vPSComments`, '')} </td>
                          </tr>
                        )
                      )
                    })

                    }

                    {/* DRAWINGS  EXTERIOR  End */}

                    {/* DRAWINGS  INTERIOR  start */}
                    {InteriorDesignTemplate.getFormName().section_8.map((item, index) => {
                      return (
                        index == 0 ? (<tr>

                          <td style={{ ...cellStyle }} rowSpan={12} > INTERIOR  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_8.${index}.completed`)} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_8.${index}.interiorDesignerComments`, '')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_8.${index}.idBidReq`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_8.${index}.pO`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_8.${index}.poOrDDue`, '', 'date')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_8.${index}.vPSComments`, '')} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_8.${index}.completed`)} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_8.${index}.interiorDesignerComments`, '')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_8.${index}.idBidReq`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_8.${index}.pO`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_8.${index}.poOrDDue`, '', 'date')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_8.${index}.vPSComments`, '')} </td>
                          </tr>
                        )
                      )
                    })

                    }
                    {/* DRAWINGS  INTERIOR  End */}


                    {InteriorDesignTemplate.getFormName().section_9.map((item, index) => {
                      return (
                        index == 0 ? (<tr>
                          <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={6}> Site Inspections Complete</td>
                          <td style={{ ...cellStyle }} rowSpan={6} >  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_9.${index}.completed`)} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_9.${index}.interiorDesignerComments`, '')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_9.${index}.idBidReq`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_9.${index}.pO`, '')} </td>
                          <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_9.${index}.poOrDDue`, '', 'date')} </td>
                          <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_9.${index}.vPSComments`, '')} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>  {renderSelect(`section_9.${index}.completed`)} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_9.${index}.interiorDesignerComments`, '')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderInputArea(`section_9.${index}.idBidReq`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_9.${index}.pO`, '')} </td>
                            <td style={{ ...cellStyleW,  }}> {renderInputArea(`section_9.${index}.poOrDDue`, '', 'date')} </td>
                            <td style={{ ...cellStyleW,  }}>  {renderTextArea(`section_9.${index}.vPSComments`, '')} </td>
                          </tr>
                        )
                      )
                    })

                    }
                    <tr>
                      <td>Risk/Safety/Client/Team/Other?</td>
                      <td style={{ ...cellStyleW,  }} colSpan={8}>  {renderTextArea('riskSafety', '')} </td>
                    </tr>




                  </tbody>
                </table>


              </div>

            </AccordionTab>

            <AccordionTab header="GENERAL PROJECTS CHECKLIST" className="mt-2">
              <div className="table-container" style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", }}>
                  <thead style={{ overflowX: "auto" }}>
                    <tr>
                      <th style={{ ...headerStyle, textAlign: 'start' }} >
                        General projects checklist:
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {preConstructionShedule.map((item, index) => {
                      return (
                        <tr>
                          <td >
                            <td style={{ ...cellStyleW, width: "300px", }}>{renderInputArea('section_10.' + index + '.genrealProjectCheckListTitle', '', '')}</td>
                            <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
                              {renderSelect('section_10.' + index + '.misc1')}
                            </td>
                            <td style={{ ...cellStyleW, minWidth: '50vw' }}>
                              {renderTextArea('section_10.' + index + '.miscReason', '')}
                            </td>
                            <td style={{ ...cellStyle, minWidth: "100px" }}>
                              {index > 0 ? (<Button icon="pi pi-trash" type="button" rounded outlined style={{ width: '30px', height: '30px' }} className="mr-2" severity="danger" onClick={() => handleDeleteInputForreConstructionShedule(index)} />) : null}
                              {preConstructionShedule.length - 1 == index ? (<Button type="button" icon="pi pi-plus" rounded outlined style={{ width: '30px', height: '30px' }} className="mr-2" onClick={() => handleAddInputForPreConstructionShedule()} />) : null}
                            </td>

                          </td>
                        </tr>

                      )
                    })}




                  </tbody>
                </table>
              </div>
            </AccordionTab>

          </Accordion>
        </div>
      </form>
    </>
  );
};

export default INTERIOR_DESIGN_TEMPLATE